











import Vue from "vue";
import { Props, Computed, Method } from "./ApplicationIndexSaleCaptionType";

export default Vue.extend<{}, Method, Computed, Props>({
  name: "vc-application-index-sale-caption",
  props: {
    isJapanSale: { default: false },
    isForeignSale: { default: false },
    japanSaleCaptionText: { default: "" },
    foreignSaleCaptionText: { default: "" }
  },
  computed: {
    saleCaptionText(): string {
      if (this.isForeignSale) {
        return this.foreignSaleCaptionText;
      }

      return this.japanSaleCaptionText;
    }
  },
  methods: {
    isSale(): boolean {
      return this.isJapanSale || this.isForeignSale;
    }
  }
});
